import { gql } from '@apollo/client';
export const UpdateEmployeeWorkDayHoursMutation = gql `
    mutation UpdateEmployeeWorkDayHours($siteSetId: InstitutionSetId!, $employeeWorkDay: Float) {
        staffhours {
            settings {
                updateEmployeeWorkDay(siteSetId: $siteSetId, employeeWorkDay: $employeeWorkDay)
            }
        }
    }
`;
